// src/components/features/Structure/components/StructureStep5Stairs.jsx
// Step 5: Stair Structure Type — Folded or Waist, simple Radio card style

import {
  Box,
  Flex,
  Text,
  Radio,
  Button,
  VStack,
} from "@chakra-ui/react";

const STAIR_TYPES = [
  {
    value: "folded",
    label: "Folded Slab Staircase",
    sub: "Slab folded at stair angle — economical, simpler formwork, suitable for small spans",
  },
  {
    value: "waist",
    label: "Waist Slab Staircase",
    sub: "Inclined waist slab with steps on top — better for longer spans, higher strength",
  },
];

export default function StructureStep5Stairs({
  formData, setFormData, onNext, onBack, isLastStep, onSubmit, viewMode,
}) {
  const stairType = formData?.structureStairType || "";

  const handleNext = () => {
    if (!viewMode && !stairType) return;
    if (isLastStep) onSubmit();
    else onNext();
  };

  return (
    <Box
      h="600px"
      w="100%"
      maxW="400px"
      mx="auto"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={4}
      py={6}
    >
      <Box
        flex="1"
        minH="0"
        overflowY="auto"
        overflowX="hidden"
        pr={2}
        css={{
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": { background: "#cbd5e0", borderRadius: "10px" },
          "& *": { pointerEvents: viewMode ? "none" : "auto" },
        }}
      >
        <VStack spacing={4} align="stretch">
          <Box textAlign="center">
            <Text fontSize="17px" fontWeight="600" color="gray.800">Structure of Stairs</Text>
            <Text fontSize="12px" color="gray.500" mt={1}>
              Select the structural type of staircase for your building
            </Text>
          </Box>

          <VStack spacing={2} align="stretch">
            {STAIR_TYPES.map((s) => {
              const isSelected = stairType === s.value;
              return (
                <Box
                  key={s.value}
                  border={isSelected ? "2px solid #319795" : "1px solid #E2E8F0"}
                  borderRadius="10px"
                  px={3}
                  py={2}
                  cursor="pointer"
                  bg={isSelected ? "cyan.50" : "white"}
                  transition="0.2s"
                  _hover={{ borderColor: "cyan.400" }}
                  onClick={() => setFormData({ ...formData, structureStairType: s.value })}
                >
                  <Flex align="center" gap={3}>
                    <Radio
                      value={s.value}
                      isChecked={isSelected}
                      onChange={() => setFormData({ ...formData, structureStairType: s.value })}
                      colorScheme="cyan"
                      size="md"
                    />
                    <Box>
                      <Text fontSize="14px" fontWeight="600" color="gray.800">{s.label}</Text>
                      <Text fontSize="11px" color="gray.500">{s.sub}</Text>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
          </VStack>

          {/* Contractor notice */}
          <Box
            bg="orange.50"
            border="1px solid"
            borderColor="orange.200"
            borderRadius="8px"
            px={3}
            py={2}
          >
            <Text fontSize="12px" color="orange.700" fontWeight="600" mb={0.5}>
              Column Shuttering Size Available
            </Text>
            <Text fontSize="11px" color="orange.600">
              Kindly confirm the column shuttering size availability with the contractor before
              finalising the structural design.
            </Text>
          </Box>
        </VStack>
      </Box>

      <Flex justify="space-between" gap={3} mt={4} flexShrink={0}>
        <Button
          onClick={onBack}
          variant="solid" bg="white" color="cyan.600"
          border="1px solid" borderColor="cyan.500"
          borderRadius="6px" minW="100px" h="40px"
          fontWeight="500" fontSize="14px"
          _hover={{ bg: "cyan.50" }}
        >
          ← Previous
        </Button>
        <Button
          onClick={handleNext}
          isDisabled={viewMode || !stairType}
          variant="solid"
          bg={(!viewMode && stairType) ? "cyan.500" : "gray.300"}
          color="white" borderRadius="6px" minW="100px" h="40px"
          fontWeight="500" fontSize="14px" ml="auto"
          _hover={{ bg: (!viewMode && stairType) ? "cyan.600" : "gray.300" }}
          _disabled={{ bg: "gray.300", color: "gray.500", cursor: "not-allowed" }}
        >
          {isLastStep ? "Submit" : "Next →"}
        </Button>
      </Flex>
    </Box>
  );
}